import { atom } from 'jotai';

import { LocaleEnum } from '@lib/enums/LocaleEnum';

type TLocale = {
  locale: LocaleEnum;
};

const INITIAL_LOCALE_STATE = {
  locale: LocaleEnum.EN_US,
} satisfies TLocale;

const LocaleAtom = atom<TLocale>(INITIAL_LOCALE_STATE);

export { LocaleAtom };
